import './chunk-851d1b8f.js';
import './helpers.js';
import './chunk-10ce22e9.js';
import './chunk-97dd88e0.js';
import './chunk-136c8df7.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-1be3b7ea.js';
import './chunk-a67eba42.js';
import './chunk-42f463e6.js';
import './chunk-a4483055.js';
import './chunk-a86155fc.js';
import './chunk-9dd7d140.js';
import { D as Datepicker } from './chunk-00513de7.js';
export { D as BDatepicker } from './chunk-00513de7.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);

export default Plugin;
